import React from 'react';
import { useVariant } from './hooks/NavBarContext';
import { NavBarTypes } from './navBarTypes';
import {
  CPHeaderLinkWrapper,
  HeaderLinkContent,
} from '../../../../components/headerLinks/HeaderLink';
import { weakKey } from '../../../../utilities/weakKey';
import { getCurrentLocation } from './helpers/SignInAvatarHelpers';

export const NavBarMenus = ({
  navLinks,
  openNavBar,
  LinkWrapper,
  globalContext,
}: NavBarTypes.TNavBarMenu) => {
  const currentDetails = useVariant();
  const selectedLocation = getCurrentLocation(
    currentDetails?.locationDetails,
    globalContext?.facilityId
  );

  return (
    <>
      {navLinks.map(
        (
          {
            NavLinkText,
            isNavLinkDropDown,
            isGrouped,
            navLinkDropDown,
            linkTo,
            newTab,
          },
          index
        ) => {
          const headerLinkContent: NavBarTypes.THeaderLinkContent = {
            locationDetails: currentDetails.locationDetails,
            NavLinkText,
            linkTo,
            navLinkDropDown,
            isGrouped,
            isNavLinkDropDown,
            openNavBar,
            LinkWrapper,
            newTab,
            globalContext,
            selectedLocationName: selectedLocation?.location_name,
          };
          return (
            <CPHeaderLinkWrapper
              NavLinkText={NavLinkText}
              key={weakKey({ linkTo })}
              className={NavLinkText.split(' ').join('')}
              index={index}
            >
              <HeaderLinkContent
                className={NavLinkText.split(' ').join('')}
                {...headerLinkContent}
              />
            </CPHeaderLinkWrapper>
          );
        }
      )}
    </>
  );
};
